import { CompositeState, TranslateOptions } from '../types/animations';
import type { Material } from 'three';
import { Composite, getArray } from './_common';
import { gsap } from 'gsap';
import { TimelineExt, TimelineWithPosition } from '../utils/combine';
// import { createLogger } from 'common/logger';

(window as any).GSAP = gsap;

// const logger = createLogger('[translateMaterial]');

export function translateMaterial<T extends Material = Material>(_materials: T | T[], options?: TranslateOptions<CompositeState>): gsap.core.Timeline;
export function translateMaterial<T extends Material = Material>(_materials: T | T[], options: TranslateOptions<CompositeState>, position: gsap.Position): TimelineWithPosition;
export function translateMaterial<T extends Material = Material>(_materials: T | T[], options?: TranslateOptions<CompositeState>, position?: gsap.Position): TimelineExt {
    const materials = getArray(_materials);
    if (!materials.length) {
        // eslint-disable-next-line no-console
        console.warn('translateMaterial: no supported objects found', materials);
        return null;
    }

    const { tl: existingTl, from, to, vars, timelineVars, reset = false } = options || { };
    const parser = Composite.createMaterialParser(materials[0]);

    if (reset && from?.material) {
        materials.forEach(m => parser.set(m, from.material as any));
    }

    const tl = existingTl ?? gsap.timeline(timelineVars);

    parser.animate(
        tl,
        materials,
        from?.material as any,
        to?.material as any,
        vars,
    );

    if (position !== undefined) {
        return { tl, position };
    }

    return tl;
}
